module.exports = "/_next/static/images/1d8817ed8db141f17460b6741ccf290a-savings-hero-xs.jpg.webp";